import type { CSSProperties, InputHTMLAttributes } from 'react'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

const inputStyle: CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '0.5rem 0.75rem',
  borderRadius: 6,
  border: '1px solid #d1d5db',
  fontSize: 14,
  fontFamily: 'inherit',
  background: '#fff',
  color: '#1f2937',
  boxSizing: 'border-box',
}

export function Input({ style, ...rest }: InputProps) {
  return <input {...rest} style={{ ...inputStyle, ...style }} />
}
